module.exports = "https://trybtryb-legacy.web.app/img/rounded-transparent-desktop.c810cfee.svg";